export enum WhitelabelBrokerEnum {
  CEDRO = 'CEDRO',
  PI = 'PI',
  RB = 'RB',
  FASTTRADE = 'CEDRO',
  FAST = 'CEDRO',
  DAYCOVAL = 'DAYCOVAL',
  FC = 'FCSTONE',
  TRINUS = 'TRINUS',
  EMPIRICUS = 'VITREO',
  RANKING = 'F2L',
  AMARIL = 'AMARIL',
  GUIDE = 'GUIDE',
  SINGULARE = 'SINGULARE'
}
